<script setup lang="ts">
import PhosphorIcon from "@/components/UI/PhosphorIcon.vue";

/** Ligne de liste : icône (ou pastille numérotée), titre, explication. */
defineProps<{
  icon?: string;
  number?: number;
  title: string;
  text: string;
}>();
</script>

<template>
  <div class="ui-item">
    <span class="ui-item-mark" :class="{ numbered: number !== undefined }">
      <PhosphorIcon v-if="icon" :name="icon" :size="18" weight="duotone" />
      <template v-else>{{ number }}</template>
    </span>
    <div class="ui-item-body">
      <div class="ui-item-title">{{ title }}</div>
      <div class="ui-item-text">{{ text }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.ui-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.ui-item-mark {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border: 1px solid var(--canvas-border);
  border-radius: 10px;
  background-color: rgba(255, 255, 255, 0.05);
  color: #fff;

  &.numbered {
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 50%;
    background-color: var(--canvas-btn-active-bg);
    color: #1a1a1a;
    font-size: 12px;
    font-weight: 700;
  }
}

.ui-item-body {
  min-width: 0;
}

.ui-item-title {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.ui-item-text {
  margin-top: 2px;
  font-size: 13px;
  line-height: 1.45;
  color: rgba(255, 255, 255, 0.7);
}
</style>
